import { millisecondsInADay } from '../constants/global.constants';

export const calculateDaysFromNow = (futureDate: Date): number => {
  const today = new Date();
  const differenceInMillisec = futureDate.getTime() - today.getTime();
  return Math.ceil(differenceInMillisec / millisecondsInADay);
};
